import { ContactResearchProviderId } from "@/types/contactResearch"
import type { ContactResearchContact, ContactResearchProviderInfo } from "@/types/contactResearch"

type ContactResearchProviderSummary = {
	contacts: number
	emails: number
	phones: number
	linkedInProfiles: number
}

function uniqueValues(values: string[], normalize: (value: string) => string): number {
	return new Set(values.map(normalize).filter(Boolean)).size
}

function normalizeText(value: string): string {
	return value.trim().toLocaleLowerCase()
}

function normalizePhone(value: string): string {
	return value.replace(/\D/g, "") || normalizeText(value)
}

export function defaultContactResearchProviderIds(
	providers: ContactResearchProviderInfo[]
): ContactResearchProviderId[] {
	return providers
		.filter(
			provider =>
				provider.id !== ContactResearchProviderId.Canada411 && provider.id !== ContactResearchProviderId.WebSearch
		)
		.map(provider => provider.id)
}

export function summarizeContactResearchProvider(contacts: ContactResearchContact[]): ContactResearchProviderSummary {
	return {
		contacts: contacts.length,
		emails: uniqueValues(
			contacts.flatMap(contact => contact.emails),
			normalizeText
		),
		phones: uniqueValues(
			contacts.flatMap(contact => [...contact.phones, ...contact.companyPhones]),
			normalizePhone
		),
		linkedInProfiles: uniqueValues(
			contacts.flatMap(contact => (contact.linkedInUrl ? [contact.linkedInUrl] : [])),
			normalizeText
		),
	}
}
